// Фото товаров для демо — нарисованы, а не скачаны.
//
// Настоящие снимки пришлось бы либо хранить в сборке, либо тянуть с чужого
// сервера. Вместо этого каждое «фото» — SVG в data-адресе: мягкий градиент в
// тоне товара и контурная иконка предмета. Оно честно выглядит как витрина
// демо-режима, ничего не весит и не уходит в сеть.
//
// Контуры иконок — из набора Lucide (lucide.dev, лицензия ISC), тот же набор,
// что уже стоит в зависимостях панели.

const ICONS = {
  bike: "<circle cx='18.5' cy='17.5' r='3.5'/><circle cx='5.5' cy='17.5' r='3.5'/><circle cx='15' cy='5' r='1'/><path d='M12 17.5V14l-3-3 4-3 2 3h2'/>",
  sofa: "<path d='M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3'/><path d='M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z'/><path d='M4 18v2'/><path d='M20 18v2'/><path d='M12 4v9'/>",
  smartphone: "<rect width='14' height='20' x='5' y='2' rx='2' ry='2'/><path d='M12 18h.01'/>",
  headphones: "<path d='M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3'/>",
  camera: "<path d='M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z'/><circle cx='12' cy='13' r='3'/>",
  lamp: "<path d='m14 5-3 3 2 7 8-8-7-2Z'/><path d='m14 5-3 3-3-3 3-3 3 3Z'/><path d='M9.5 6.5 4 12l3 6'/><path d='M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z'/>",
  armchair: "<path d='M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3'/><path d='M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z'/><path d='M5 18v2'/><path d='M19 18v2'/>",
  guitar: "<path d='m11.9 12.1 4.514-4.514'/><path d='M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z'/><path d='m6 16 2 2'/><path d='M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z'/>",
  gamepad: "<line x1='6' x2='10' y1='11' y2='11'/><line x1='8' x2='8' y1='9' y2='13'/><line x1='15' x2='15.01' y1='12' y2='12'/><line x1='18' x2='18.01' y1='10' y2='10'/><path d='M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z'/>",
  watch: "<circle cx='12' cy='12' r='6'/><polyline points='12 10 12 12 13 13'/><path d='m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05'/><path d='m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05'/>",
  laptop: "<path d='M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16'/>",
  coffee: "<path d='M10 2v2'/><path d='M14 2v2'/><path d='M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1'/><path d='M6 2v2'/>",
  book: "<path d='M12 7v14'/><path d='M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z'/>",
  speaker: "<rect width='16' height='20' x='4' y='2' rx='2'/><path d='M12 6h.01'/><circle cx='12' cy='14' r='4'/><path d='M12 14h.01'/>",
  drill: "<path d='M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z'/><path d='M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8'/><path d='M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3'/><path d='M18 6h4'/><path d='m5 10-2 8'/><path d='m7 18 2-8'/>",
  tent: "<path d='M3.5 21 14 3'/><path d='M20.5 21 10 3'/><path d='M15.5 21 12 15l-3.5 6'/><path d='M2 21h20'/>",
  tv: "<rect width='20' height='15' x='2' y='7' rx='2' ry='2'/><polyline points='17 2 12 7 7 2'/>",
  shirt: "<path d='M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z'/>",
  sneakers: "<path d='M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z'/><path d='M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z'/><path d='M16 17h4'/><path d='M4 13h4'/>",
  plant: "<path d='M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1'/><circle cx='12' cy='8' r='2'/><path d='M12 10v12'/><path d='M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z'/><path d='M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z'/>",
  keyboard: "<path d='M10 8h.01'/><path d='M12 12h.01'/><path d='M14 8h.01'/><path d='M16 12h.01'/><path d='M18 8h.01'/><path d='M6 8h.01'/><path d='M7 16h10'/><path d='M8 12h.01'/><rect width='20' height='16' x='2' y='4' rx='2'/>",
  baby: "<path d='M9 12h.01'/><path d='M15 12h.01'/><path d='M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5'/><path d='M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1'/>"
};

// Три ракурса одного товара: второе и третье «фото» — тот же предмет крупнее и
// со сдвигом, чтобы галерея не состояла из трёх одинаковых картинок.
const ANGLES = [
  { scale: 10, x: 200, y: 112, tilt: 0 },
  { scale: 13, x: 150, y: 70, tilt: -8 },
  { scale: 8, x: 236, y: 140, tilt: 6 }
];

const cache = new Map();

export const productImage = (kind, hue = 230, angle = 0) => {
  const key = `${kind}|${hue}|${angle}`;
  const cached = cache.get(key);
  if (cached) return cached;
  const icon = ICONS[kind] || ICONS.shirt;
  const view = ANGLES[angle % ANGLES.length];
  const hue2 = (hue + 32) % 360;
  const svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 480' width='640' height='480'>"
    + "<defs>"
    + `<linearGradient id='b' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='hsl(${hue},34%,34%)'/><stop offset='1' stop-color='hsl(${hue2},40%,13%)'/></linearGradient>`
    + `<radialGradient id='g' cx='0.5' cy='0.42' r='0.6'><stop offset='0' stop-color='hsl(${hue},80%,78%)' stop-opacity='0.32'/><stop offset='1' stop-color='hsl(${hue},80%,78%)' stop-opacity='0'/></radialGradient>`
    + "</defs>"
    + "<rect width='640' height='480' fill='url(#b)'/>"
    + "<rect width='640' height='480' fill='url(#g)'/>"
    + "<ellipse cx='320' cy='398' rx='150' ry='16' fill='#000' opacity='0.24'/>"
    + `<g transform='rotate(${view.tilt} 320 240) translate(${view.x} ${view.y}) scale(${view.scale})' fill='none' stroke='#fff' stroke-width='${(1.35 * 10 / view.scale).toFixed(2)}' stroke-linecap='round' stroke-linejoin='round' opacity='0.94'>${icon}</g>`
    + "</svg>";
  const url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  cache.set(key, url);
  return url;
};

export const productGallery = (kind, hue, count = 3) => (
  Array.from({ length: Math.max(1, count) }, (_, index) => productImage(kind, hue, index))
);

// Картинка из файла, который выбрал сам человек (фото к сообщению, к редактору
// фото), — в data-адрес, чтобы песочница могла вернуть её как «загруженную».
export const fileToDataUrl = (file) => new Promise((resolve) => {
  if (!file || typeof FileReader === "undefined") {
    resolve("");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result || ""));
  reader.onerror = () => resolve("");
  reader.readAsDataURL(file);
});

// «Обработка» фото в демо: нейросеть не вызывается, снимок чуть высветляется
// на холсте и получает пометку DEMO. Так видно, как работает редактор, и видно,
// что это не настоящий результат.
export const demoRetouch = (dataUrl, caption = "") => new Promise((resolve) => {
  if (!dataUrl || typeof document === "undefined") {
    resolve(dataUrl);
    return;
  }
  const image = new Image();
  image.onload = () => {
    try {
      const maxSide = 1280;
      const ratio = Math.min(1, maxSide / Math.max(image.naturalWidth || 1, image.naturalHeight || 1));
      const width = Math.max(1, Math.round((image.naturalWidth || 640) * ratio));
      const height = Math.max(1, Math.round((image.naturalHeight || 480) * ratio));
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext("2d");
      context.filter = "brightness(1.08) contrast(1.06) saturate(1.12)";
      context.drawImage(image, 0, 0, width, height);
      context.filter = "none";
      const pad = Math.round(Math.max(10, width * 0.02));
      const fontSize = Math.round(Math.max(12, width * 0.026));
      const label = caption ? `DEMO · ${caption}` : "DEMO";
      context.font = `700 ${fontSize}px Manrope, system-ui, sans-serif`;
      const textWidth = context.measureText(label).width;
      const boxHeight = fontSize + pad;
      context.fillStyle = "rgba(10,11,15,0.62)";
      context.fillRect(pad, height - boxHeight - pad, textWidth + pad * 2, boxHeight);
      context.fillStyle = "#ffffff";
      context.textBaseline = "middle";
      context.fillText(label, pad * 2, height - pad - boxHeight / 2);
      resolve(canvas.toDataURL("image/jpeg", 0.9));
    } catch (_) {
      resolve(dataUrl);
    }
  };
  image.onerror = () => resolve(dataUrl);
  image.src = dataUrl;
});

export const dataUrlToBlob = (dataUrl) => {
  const match = String(dataUrl || "").match(/^data:([^;,]+)(;base64)?,(.*)$/);
  if (!match) return new Blob([], { type: "application/octet-stream" });
  const mime = match[1];
  if (match[2]) {
    const binary = atob(match[3]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  }
  return new Blob([decodeURIComponent(match[3])], { type: mime });
};
